import { Action } from 'redux'

import { Pagination } from '../../lib/interfaces/Pagination.interface'
import { Termination } from '../../lib/interfaces/Termination.interface'
import TerminationFormData from '../../routes/terminations/termination-flow/TerminationFormData.interface'

export const actionTypes = {
  TERMINATIONS_FETCH_LIST: 'TERMINATIONS_FETCH_LIST',
  TERMINATIONS_FETCH_LIST_FAILED: 'TERMINATIONS_FETCH_LIST_FAILED',
  TERMINATIONS_FETCH_LIST_SUCCESS: 'TERMINATIONS_FETCH_LIST_SUCCESS',

  TERMINATIONS_RESET_LIST: 'TERMINATIONS_RESET_LIST',

  TERMINATIONS_FETCH: 'TERMINATIONS_FETCH',
  TERMINATIONS_FETCH_FAILED: 'TERMINATIONS_FETCH_FAILED',
  TERMINATIONS_FETCH_SUCCESS: 'TERMINATIONS_FETCH_SUCCESS',

  TERMINATIONS_CREATE: 'TERMINATIONS_CREATE',
  TERMINATIONS_CREATE_FAILED: 'TERMINATIONS_CREATE_FAILED',
  TERMINATIONS_CREATE_SUCCESS: 'TERMINATIONS_CREATE_SUCCESS',

  TERMINATIONS_UPDATE: 'TERMINATIONS_UPDATE',
  TERMINATIONS_UPDATE_FAILED: 'TERMINATIONS_UPDATE_FAILED',
  TERMINATIONS_UPDATE_SUCCESS: 'TERMINATIONS_UPDATE_SUCCESS',

  TERMINATIONS_CONFIRM: 'TERMINATIONS_CONFIRM',
  TERMINATIONS_CONFIRM_FAILED: 'TERMINATIONS_CONFIRM_FAILED',
  TERMINATIONS_CONFIRM_SUCCESS: 'TERMINATIONS_CONFIRM_SUCCESS',

  TERMINATIONS_DELETE: 'TERMINATIONS_DELETE',
  TERMINATIONS_DELETE_FAILED: 'TERMINATIONS_DELETE_FAILED',
  TERMINATIONS_DELETE_SUCCESS: 'TERMINATIONS_DELETE_SUCCESS'
}

/**
 * Fetch Terminations
 */
export interface TerminationFetchListAction extends Action {
  payload: {
    page?: number
    next?: () => void
  }
}

export const fetchTerminations = (page?: number, next?: () => void): TerminationFetchListAction => ({
  type: actionTypes.TERMINATIONS_FETCH_LIST,
  payload: { page, next }
})

/**
 * Fetch Terminations Success
 */
export interface TerminationFetchListSuccessAction extends Action {
  payload: {
    terminationListResponse: Pagination<Termination>
  }
}

export const fetchTerminationsSuccess = (terminationListResponse: Pagination<Termination>): TerminationFetchListSuccessAction => ({
  type: actionTypes.TERMINATIONS_FETCH_LIST_SUCCESS,
  payload: { terminationListResponse }
})

 /**
  * Fetch Terminations Error
  */
 export interface TerminationFetchListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
 }

 export const fetchTerminationsFailure = (errorMessage?: string): TerminationFetchListErrorAction => ({
  type: actionTypes.TERMINATIONS_FETCH_LIST_FAILED,
  payload: { errorMessage }
 })

 /**
  * Reset Terminations List
  */
export const resetTerminationsList = (): Action => ({
  type: actionTypes.TERMINATIONS_RESET_LIST
})

 /**
  * Fetch Termination
  */
export interface TerminationFetchAction extends Action {
  payload: {
    terminationId: string
    next?: (err?: any, termination?: Termination) => void
  }
}

export const fetchTermination = (terminationId: string, next?: (err?: any, termination?: Termination) => void): TerminationFetchAction => ({
  type: actionTypes.TERMINATIONS_FETCH,
  payload: { next, terminationId }
})

// success
export interface TerminationFetchSuccessAction extends Action {
  payload: {
    termination: Termination
  }
}

export const fetchTerminationSuccess = (termination: Termination): TerminationFetchSuccessAction => ({
  type: actionTypes.TERMINATIONS_FETCH_SUCCESS,
  payload: { termination }
})

// error
export interface TerminationFetchErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchTerminationError = (errorMessage?: string): TerminationFetchErrorAction => ({
  type: actionTypes.TERMINATIONS_FETCH_FAILED,
  payload: { errorMessage }
})

 /**
  * Create Termination
  */
 export interface TerminationCreateAction extends Action {
   payload: {
     termination: TerminationFormData
     next?: (err?: any, termination?: Termination) => void
   }
 }

 export const createTermination = (termination: TerminationFormData, next?: (err?: any, termination?: Termination) => void): TerminationCreateAction => ({
   type: actionTypes.TERMINATIONS_CREATE,
   payload: { next, termination }
 })

 // Error
 export interface TerminationCreateErrorAction extends Action {
   payload: {
     errorMessage?: string
   }
 }

 export const createTerminationError = (errorMessage?: string): TerminationCreateErrorAction => ({
   type: actionTypes.TERMINATIONS_CREATE_FAILED,
   payload: { errorMessage }
 })

 // Success
 export interface TerminationCreateSuccessAction extends Action {
   payload: {
     termination: Termination
   }
 }

export const createTerminationSuccess = (termination: Termination): TerminationCreateSuccessAction => ({
  type: actionTypes.TERMINATIONS_CREATE_SUCCESS,
  payload: { termination }
})

/**
 * Update Termination
 */
export interface TerminationUpdateAction extends Action {
  payload: {
    terminationId: string
    termination: TerminationFormData
    next?: (err?: any, termination?: Termination) => void
  }
}

export const updateTermination = (terminationId: string, termination: TerminationFormData, next?: (err?: any, termination?: Termination) => void): TerminationUpdateAction => ({
  type: actionTypes.TERMINATIONS_UPDATE,
  payload: { next, termination, terminationId }
})

// Error
export interface TerminationUpdateErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const updateTerminationError = (errorMessage?: string): TerminationUpdateErrorAction => ({
  type: actionTypes.TERMINATIONS_UPDATE_FAILED,
  payload: { errorMessage }
})

// Success
export interface TerminationUpdateSuccessAction extends Action {
  payload: {
    termination: Termination
  }
}

export const updateTerminationSuccess = (termination: Termination): TerminationUpdateSuccessAction => ({
  type: actionTypes.TERMINATIONS_UPDATE_SUCCESS,
  payload: { termination }
})

/**
 * Confirm Termination
 */
export interface TerminationConfirmAction extends Action {
  payload: {
    terminationId: string
    next?: (err?: any, termination?: Termination) => void
  }
}

export const confirmTermination = (terminationId: string, next?: (err?: any, termination?: Termination) => void): TerminationConfirmAction => ({
  type: actionTypes.TERMINATIONS_CONFIRM,
  payload: { next, terminationId }
})

// Error
export interface TerminationConfirmErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const confirmTerminationError = (errorMessage?: string): TerminationConfirmErrorAction => ({
  type: actionTypes.TERMINATIONS_CONFIRM_FAILED,
  payload: { errorMessage }
})

// Success
export interface TerminationConfirmSuccessAction extends Action {
  payload: {
    termination: Termination
  }
}

export const confirmTerminationSuccess = (termination: Termination): TerminationConfirmSuccessAction => ({
  type: actionTypes.TERMINATIONS_CONFIRM_SUCCESS,
  payload: { termination }
})

/**
 * Delete Termination
 */
export interface TerminationDeleteAction extends Action {
  payload: {
    terminationId: string
    next?: (err?: any) => void
  }
}

export const deleteTermination = (terminationId: string, next?: (err?: any) => void): TerminationDeleteAction => ({
  type: actionTypes.TERMINATIONS_DELETE,
  payload: { next, terminationId }
})

// Error
export interface TerminationDeleteErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const deleteTerminationError = (errorMessage?: string): TerminationDeleteErrorAction => ({
  type: actionTypes.TERMINATIONS_DELETE_FAILED,
  payload: { errorMessage }
})

// Success
export interface TerminationDeleteSuccessAction extends Action {
  payload: {
    terminationId: string
  }
}

export const deleteTerminationSuccess = (terminationId: string): TerminationDeleteSuccessAction => ({
  type: actionTypes.TERMINATIONS_DELETE_SUCCESS,
  payload: { terminationId }
})

export type ActionTypes =
    TerminationFetchListAction
  | TerminationFetchListSuccessAction
  | TerminationFetchListErrorAction
  | TerminationFetchAction
  | TerminationFetchSuccessAction
  | TerminationFetchErrorAction
  | TerminationCreateAction
  | TerminationCreateErrorAction
  | TerminationCreateSuccessAction
  | TerminationConfirmAction
  | TerminationConfirmErrorAction
  | TerminationConfirmSuccessAction



// WEBPACK FOOTER //
// ./src/store/terminations/actions.ts